import React, { useState } from "react";

const SingleTaskingModal = ({ closeModal, onCreate }) => {
    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [category, setCategory] = useState("priorities_action_list");

    const categories = {
        "priorities_action_list": "PRIORITIES & NON-NEGOTIABLE",
        "secondary_action_list": "SECONDARY",
        "easiest_action_list": "EASIEST & FAVORITE",
        "clustering_action_list": "CLUSTERING",
        "delegating_action_list": "DELEGATING",
    };

    const handleCreate = () => {
        if (title.trim() === "") {
            alert("Title is required.");
        } else {
            const newTask = {
                title,
                description,
                category,
            };
            onCreate(newTask);
            closeModal();
        }
    };
    return (
        <div className="modal fade show modal-overlay" style={{ display: "block" }}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title">Create a new task</h4>
                        <button className="btn-close" type="button" aria-label="Close" onClick={closeModal}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label htmlFor="taskTitle" className="form-label">Single-task title*</label>
                            <input
                                type="text"
                                className="form-control"
                                id="taskTitle"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="taskDescription" className="form-label">Next action list</label>
                            <textarea
                                className="form-control"
                                id="taskDescription"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                rows={4}
                            />
                        </div>
                        <div className="mb-3">
                            <label htmlFor="taskCategory" className="form-label">Task Category</label>
                            <select
                                className="form-select"
                                id="taskCategory"
                                value={category}
                                onChange={(e) => setCategory(e.target.value)}
                            >
                                {Object.keys(categories).map((key) => (
                                    <option key={key} value={key}>
                                        {categories[key]}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button className="btn btn-light" type="button" onClick={closeModal}>
                            Close
                        </button>
                        <button className="btn btn-primary" type="button" onClick={handleCreate}>
                            Create
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SingleTaskingModal;
